export const INSERT_LINK_ERROR_CODE = 'InsertLinks';
export const FORGOTTEN_ATTACHMENTS_ERROR_CODE = 'ForgottenAttachments';
export const PENDING_PERMISSION_ERROR_CODE = 'PendingPermission';
export const SHARING_ISSUE_ERROR_CODE = 'SharingIssue';
